import api from './api';

export const getMarketsApi = (params) => api().get('/options-markets', { params });
export const addNewMarketApi = (data) => api().post('/options-markets', data);
export const deleteMarketsApi = (params) => api().delete('/options-markets', { params });
export const updateMarketsApi = (params) => api().put(`/options-markets/${params.id}`, params.values);
